export function convertUnicodeText(strByCodifier) {    
    if(strByCodifier){
      let strEncoded = convertEmojisToUnicodeInText(strByCodifier);
  
      strEncoded = toUnicodeEscape(strEncoded);
  
      // const utf8Bytes = new TextEncoder().encode(strEncoded);
      // strEncoded = btoa(String.fromCharCode(...utf8Bytes));
      return strEncoded;
    }
    return "";
  }
  
  export function codeBase64Convert(strByCodifier,addBackslash) {    
      if(strByCodifier){
        let strEncoded = convertEmojisToUnicodeInText(strByCodifier);
  
        strEncoded = toUnicodeEscape(strEncoded);
  
        if(addBackslash){
          strEncoded = strEncoded.replace(/\\/g, '\\\\');
        }
        const utf8Bytes = new TextEncoder().encode(strEncoded);
        strEncoded = btoa(String.fromCharCode(...utf8Bytes));
        return strEncoded;
      }
      return "";
  }
  
  export function codeBase64ConvertV2(strByCodifier,addBackslash) {    
    if(strByCodifier){
      let strEncoded = convertEmojisToUnicodeInText(strByCodifier);
  
      if(addBackslash){
        strEncoded = strEncoded.replace(/\\/g, '\\\\');
      }
      const utf8Bytes = new TextEncoder().encode(strEncoded);
      strEncoded = btoa(String.fromCharCode(...utf8Bytes));
      return strEncoded;
    }
    return "";
  }
  
  const toUnicodeEscape = (text) => {
    return text.replace(
      /[^\x20-\x7E\u00A0-\u00FF]/g,
      (char) => `\\u${char.charCodeAt(0).toString(16).padStart(4, "0")}`
    );
  };
  
  function toHex16Bit(x) {
    const hi = (x >> 8) & 0xff;
    const lo = x & 0xff;
    return hi.toString(16).padStart(2, '0') + lo.toString(16).padStart(2, '0');
  }
  
  function utf8ToCodepoint(str, index, end) {
    const REPLACEMENT_CHARACTER = 0xFFFD;
    if (index >= end) return { codepoint: REPLACEMENT_CHARACTER, newIndex: index + 1 };
    
    let firstByte = str.codePointAt(index);
    
    if (firstByte < 0x80) {
        return { codepoint: firstByte, newIndex: index + 1 };
    }
    
    if (firstByte < 0xE0) {
        if (index + 1 >= end) return { codepoint: REPLACEMENT_CHARACTER, newIndex: index + 1 };
        let calculated = ((firstByte & 0x1F) << 6) | (str.codePointAt(index + 1) & 0x3F);
        return { codepoint: calculated < 0x80 ? REPLACEMENT_CHARACTER : calculated, newIndex: index + 2 };
    }
    
    if (firstByte < 0xF0) {
        if (index + 2 >= end) return { codepoint: REPLACEMENT_CHARACTER, newIndex: index + 1 };
        let calculated = ((firstByte & 0x0F) << 12) |
                         ((str.codePointAt(index + 1) & 0x3F) << 6) |
                         (str.codePointAt(index + 2) & 0x3F);
        if (calculated >= 0xD800 && calculated <= 0xDFFF) return { codepoint: REPLACEMENT_CHARACTER, newIndex: index + 3 };
        return { codepoint: calculated < 0x800 ? REPLACEMENT_CHARACTER : calculated, newIndex: index + 3 };
    }
    
    if (firstByte < 0xF8) {
        if (index + 3 >= end) return { codepoint: REPLACEMENT_CHARACTER, newIndex: index + 1 };
        let calculated = ((firstByte & 0x07) << 18) |
                         ((str.codePointAt(index + 1) & 0x3F) << 12) |
                         ((str.codePointAt(index + 2) & 0x3F) << 6) |
                         (str.codePointAt(index + 3) & 0x3F);
        return { codepoint: calculated < 0x10000 ? REPLACEMENT_CHARACTER : calculated, newIndex: index + 4 };
    }
    
    return { codepoint: REPLACEMENT_CHARACTER, newIndex: index + 1 };
  }
  
  function convertEmojisToUnicodeInText(input) { 
      let result = '';
      let i = 0;
    
      while (i < input.length) {
        const codePoint = input.codePointAt(i);
    
        if (codePoint > 0xFFFF) {
          // É um caractere fora do BMP, calculando os pares substitutos
          const highSurrogate = ((codePoint - 0x10000) >> 10) + 0xD800;
          const lowSurrogate = ((codePoint - 0x10000) % 0x400) + 0xDC00;
    
          result += `\\u${highSurrogate.toString(16).toUpperCase().padStart(4, '0')}`;
          result += `\\u${lowSurrogate.toString(16).toUpperCase().padStart(4, '0')}`;
          i++; // Salta o par substituto baixo
        } else if (
          (codePoint >= 0x1F1E6 && codePoint <= 0x1F1FF) || // Bandeiras (Indicadores Regionais)
          (codePoint >= 0x1F300 && codePoint <= 0x1F5FF) || // Símbolos e Pictogramas Diversos
          (codePoint >= 0x1F600 && codePoint <= 0x1F64F) || // Emoticons
          (codePoint >= 0x1F680 && codePoint <= 0x1F6FF) || // Símbolos de Transporte e Mapa
          (codePoint >= 0x1F900 && codePoint <= 0x1F9FF) || // Símbolos e Pictogramas Suplementares
          (codePoint >= 0x1FA70 && codePoint <= 0x1FAFF) || // Símbolos e Pictogramas Estendidos-A
          (codePoint >= 0x2600 && codePoint <= 0x26FF) ||   // Símbolos Miscelâneos
          (codePoint >= 0x2700 && codePoint <= 0x27BF) ||   // Dingbats
          (codePoint >= 0x2300 && codePoint <= 0x23FF) ||   // Símbolos técnicos (inclui ⏳)
          (codePoint === 0x200D)                            // Zero Width Joiner
        ) {
          // Converte o código para o formato Unicode
          result += `\\u${codePoint.toString(16).toUpperCase().padStart(4, '0')}`;
        } else {
          // Retorna o caractere original se não for emoji
          result += input[i];
        }
        
        i++;
      }
  
      result = result.replace(/[\uFE00-\uFE0F]/g, '')
    
      return result;
    }